// // features/partyDetailsSlice.js
// import { createSlice } from "@reduxjs/toolkit";

// const partyDetailsSlice = createSlice({
//   name: "users",
//   initialState: [],
//   reducers: {
//     addUser: (state, action) => {
//       state.push(action.payload);
//     },
//     removeUser: (state, action) => {
//       return state.filter((user) => user.pcode !== action.payload.pcode);
//     },
//     updateUser: (state, action) => {
//       const index = state.findIndex(
//         (user) => user.pcode === action.payload.pcode
//       );
//       if (index !== -1) {
//         state[index] = { ...state[index], ...action.payload };
//       }
//     },
//     clearUsers: () => {
//       return [];
//     },
//   },
// });

// export const { addUser, removeUser, updateUser, clearUsers } =
//   partyDetailsSlice.actions;

// export default partyDetailsSlice.reducer;

// features/partyDetailsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const partyDetailsSlice = createSlice({
  name: "partyDetails",
  initialState: [],
  reducers: {
    addUser: (state, action) => {
      state.push(action.payload);
    },
    removeUser: (state, action) => {
      return state.filter((user) => user.pCode !== action.payload.pCode);
    },
    updateUser: (state, action) => {
      const index = state.findIndex(
        (user) => user.pCode === action.payload.pCode
      );
      if (index !== -1) {
        state[index] = { ...state[index], ...action.payload };
      }
    },
    clearUsers: () => {
      return [];
    },
  },
});

export const { addUser, removeUser, updateUser, clearUsers } =
  partyDetailsSlice.actions;
export default partyDetailsSlice.reducer;
